import { useNavigate } from 'react-router-dom'

export const useGoToScanContainer = () => {
  const navigate = useNavigate()

  return {
    go: (orderId: string, docId: string) => {
      navigate(
        SCAN_CONTAINER_URL.replace(':orderId', orderId).replace(':docId', docId)
      )
    }
  }
}

export const SCAN_CONTAINER_URL =
  '/inventory-transfer/:orderId/:docId/scan-container'
